const $ = window.jQuery;
const $window = window.$window || $(window);


const Menu = {

  init () {
    var $hamburger = $('.hamburger');
    if (!$hamburger.length)
        return;

    $('.hamburger, .close').on('click', function(){
      $('body').toggleClass('open');
    });
  }
  
};

export default Menu;